const OPTION_SYMBOL_PATTERN = /^(?:O:)?([A-Z]+)(\d{6})([CP])(\d+)$/;

const FINANCIAL_MODELING_PREP_LOGO_BASE_URL = "https://financialmodelingprep.com/image-stock";

export const XQUANT_FALLBACK_LOGO_URL = "/favicon.svg";

const normalizeText = (value: string): string => value.trim().toUpperCase();

export const isCashSymbol = (symbol: string | null | undefined): boolean => (
  normalizeSymbol(symbol) === "CASH"
);

export const normalizeSymbol = (rawSymbol: string | null | undefined): string => {
  if (typeof rawSymbol !== "string") {
    return "";
  }
  return normalizeText(rawSymbol);
};

export const extractUnderlyingSymbol = (rawSymbol: string | null | undefined): string => {
  const normalized = normalizeSymbol(rawSymbol);
  if (!normalized) {
    return "";
  }

  const optionMatch = normalized.match(OPTION_SYMBOL_PATTERN);
  if (optionMatch) {
    return optionMatch[1];
  }

  return normalized;
};

const toLogoLookupSymbol = (symbol: string): string => symbol.replace(/\//g, "-");

export const buildDefaultLogoUrlForSymbol = (
  rawSymbol: string | null | undefined,
): string | null => {
  const underlying = extractUnderlyingSymbol(rawSymbol);
  if (!underlying || isCashSymbol(underlying)) {
    return null;
  }

  return `${FINANCIAL_MODELING_PREP_LOGO_BASE_URL}/${encodeURIComponent(toLogoLookupSymbol(underlying))}.png`;
};

const normalizeLogoUrl = (logoUrl: string | null | undefined): string | null => {
  if (typeof logoUrl !== "string") {
    return null;
  }
  const trimmed = logoUrl.trim();
  return trimmed ? trimmed : null;
};

export const resolveLogoUrlForSymbol = (
  rawSymbol: string | null | undefined,
  explicitLogoUrl?: string | null,
): string => {
  const normalizedExplicitUrl = normalizeLogoUrl(explicitLogoUrl);
  if (normalizedExplicitUrl) {
    return normalizedExplicitUrl;
  }

  const symbolDerivedUrl = buildDefaultLogoUrlForSymbol(rawSymbol);
  if (symbolDerivedUrl) {
    return symbolDerivedUrl;
  }

  return XQUANT_FALLBACK_LOGO_URL;
};
